'use strict';

var App = App || {};

// On the magazine template there are dynamically sized feature squares in the galleries div.
// These have to be size and resized properly on load and window resize respectively.
App.MagazineLayout = function () {
  'use strict';

  var $featureLeft = $('.feature-left .feature-image-link'),
      $featuresRight = $('.feature-right .feature-image-link'),
      $galleryItemsRight = $('.feature-right .gallery-tile-item');

  var initialize = function initialize() {
    _sizeAll();
    _bindWindowResizeFeatures();
  };

  var _bindWindowResizeFeatures = function _bindWindowResizeFeatures() {
    $(window).resize(_sizeAll);
  };

  var _sizeAll = function _sizeAll() {
    if (Foundation.MediaQuery.atLeast('large')) {
      _sizeFeatureSquare();
      _sizeFeaturesSide();
    } else {
      _unsizeFeaturesSquare();
      _unsizeFeaturesSide();
    }
  };

  var _sizeFeatureSquare = function _sizeFeatureSquare(unset) {
    var width = $featureLeft.width();

    $featureLeft.height(width);
  };

  var _sizeFeaturesSide = function _sizeFeaturesSide() {
    var gutter = $galleryItemsRight.css('margin-bottom'),
        gutterOffset,
        heightToAssign;

    if (gutter) {
      gutterOffset = gutter.replace(/\D/g, '') / 2;
      heightToAssign = $featureLeft.height() / 2 - gutterOffset + 'px';
    }

    $featuresRight.height(heightToAssign);
  };

  var _unsizeFeaturesSquare = function _unsizeFeaturesSquare() {
    $featureLeft.css('height', '');
  };

  var _unsizeFeaturesSide = function _unsizeFeaturesSide() {
    $featuresRight.css('height', '');
  };

  return {
    initialize: initialize
  };
}();